import { create } from "zustand";

type Callback = (date: Date | null) => void;
interface State {
    sku: number | null;
    title: string | null;
    callback: Callback | null;
    setCallback: (callback: Callback, date: Date | null) => void;
    date: Date | null;
    selectedSchedule: string | null;
    schedules: string[];
    update: (data: Partial<State>) => void;
}

export const useCalendar = create<State>((set) => ({
    title: null,
    callback: null,
    sku: null,
    selectedSchedule: null,
    schedules: [],
    setCallback: (callback, date) => {
        set((state) => ({
            ...state,
            setActiveDate: callback,
            date
        }));
    },
    date: null,
    update: (data) => set((state) => ({ ...state, ...data })),
}));
